/*
CC Attribution License
https://www.svgrepo.com/svg/532241/certificate-check
*/

const CertificateIcon = ({ size = 18, className = "", style, stroke, ...props }) => {
    const sizeClass = typeof size === "string" ? `certificate_icon--${size}` : "";
    const width = typeof size === "number" ? size : undefined;
    const height = typeof size === "number" ? size : undefined;
    const strokeWidth = stroke !== undefined ? stroke : "var(--icon-stroke-width, 2)";

    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={`certificate_icon ${sizeClass} ${className}`}
            style={style}
            {...props}
        >
            <path
                d="M9 12L11 14L15 10M12 3L13.9101 4.87147L16.5 4.20577L17.2184 6.78155L19.7942 7.5L19.1285 10.0899L21 12L19.1285 13.9101L19.7942 16.5L17.2184 17.2184L16.5 19.7942L13.9101 19.1285L12 21L10.0899 19.1285L7.5 19.7942L6.78155 17.2184L4.20577 16.5L4.87147 13.9101L3 12L4.87147 10.0899L4.20577 7.5L6.78155 6.78155L7.5 4.20577L10.0899 4.87147L12 3Z"
                stroke="currentColor"
                strokeWidth={strokeWidth}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default CertificateIcon;